import { JourneyUser } from './journey-user';

export class JourneyDetail {
  id: number;
  name: string;
  browseable: boolean; // can be seen by users who are not enrolled in Journey
  description: string;
  duration: number; // in days
  credit_hours: number;
  private_for?: number; // subscription ID
  users: JourneyUser[];
  sync_subscription_users: boolean;
  enable_welcome_notification: boolean;
  subscription_name: string | null;
  image: string | null;
  media_video_id: number | null;
  media_video_url: string | null;
  show_certificate: boolean;
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/journey/journey-detail.ts